import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { DESKTOP_MEDIA_QUERY } from './responsive-breakpoints';
import { ResponsiveConditionDirective } from './responsive-condition.directive';

@Directive({
  selector: '[desktop]'
})
export class DesktopDirective extends ResponsiveConditionDirective {
  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef) {
    super(templateRef, viewContainer, DESKTOP_MEDIA_QUERY);
  }
}
